import React, { Component } from "react";
import config from 'react-global-configuration';
import axios from "axios";
import { BeatLoader } from "react-spinners";

class CrispMerchantTradeNameFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tradeNameList: [],
            selectedTradeNames: [],
            isLoading: true,
            isListOpen: false,
            headerTitle: "Select [Merchant Name]",
            searchQuery: ""
        };
        this.closeDropdown = this.closeDropdown.bind(this);
    }

    componentDidMount() {
        this.fetchTradeNames(false, "");
        window.addEventListener("click", this.closeDropdown);
    }

    componentWillUnmount() {
        window.removeEventListener("click", this.closeDropdown);
    }

    fetchTradeNames(isSearch = false, searchQuery = "") {
        if(isSearch===false){
            this.setState({
                selectedTradeNames:[]
            })
        }
        this.setState({ isLoading: true });
        axios
            .post(config.get("API_URL") + "/filters/get-crisp-merchant-trade-names", {
                search_query: searchQuery,
                selected_values: this.state.selectedTradeNames.map(item => item.value)
            }, {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`,
                }
            })
            .then((response) => {
                let tradeNames = response.data.map((item) => ({
                    value: item.trade_name || "NA",
                    label: item.trade_name || "NA",
                }));
                const selected = (this.props.value || []).map(val => ({
                    value: val,
                    label: val
                }));
                this.setState({
                    tradeNameList: tradeNames,
                    isLoading: false,
                    selectedTradeNames:selected
                });
            })
            .catch((err) => {
                console.error(err);
                this.setState({ isLoading: false });
            });
    }

    toggleDropdown = () => {
        this.setState((prevState) => ({
            isListOpen: !prevState.isListOpen,
        }));
    };

    closeDropdown(e) {
        if (this.dropdownRef && !this.dropdownRef.contains(e.target)) {
            this.setState({ isListOpen: false });
        }
    }

    handleSearch = (e) => {
        const query = e.target.value;
        this.setState({ searchQuery: query });
        setTimeout(() => {
            this.fetchTradeNames(true, query);
        }, 300);
    };

    handleSelect(item, checked) {
        let selected = [...this.state.selectedTradeNames];
        if (checked) {
            selected.push(item);
        } else {
            selected = selected.filter((i) => i.value !== item.value);
        }
        this.setState({ selectedTradeNames: selected });
        this.props.onSelectCrispMerchantTradeName(
            selected,
            selected.map((s) => s.value)
        );
    }
    removeCrispMerchantTradeName = () => {
        const val = ''; // clear selected values
        this.props.onSelectCrispMerchantTradeName(val); // notify parent
        this.setState({
            selectedTradeNames: [],
            tradeNameList: [], // optional: clear list
            searchQuery: "" // reset search
        });
    };

    render() {
        const { tradeNameList, selectedTradeNames, isListOpen, isLoading } = this.state;
        return (
            <div className="dd-wrapper" ref={(ref) => (this.dropdownRef = ref)}>
                <div className="dd-header" onClick={this.toggleDropdown}>
                    {selectedTradeNames.length === 0 ? (
                        <div className="dd-header-title">Select [Merchant Name]</div>
                    ) : (
                        <div className="dd-header-title">{selectedTradeNames.length} Selected</div>
                    )}
                    <i className="fa fa-angle-down"></i>
                </div>

                {isListOpen && (
                    <div
                        role="list"
                        onClick={(e) => e.stopPropagation()}
//                         style={{ position: "relative" }}
                    >
                        <input
                            className="dd-list-search-bar"
                            placeholder="Search"
                            value={this.state.searchQuery}
                            onChange={this.handleSearch}
                        />
                        <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                        <ul className="dd-list">
                            {isLoading ? (
                                <li>
                                    <BeatLoader size={5} color="#666" loading={true} />
                                </li>
                            ) : (
                                tradeNameList.map((item, index) => {
                                    const checked = selectedTradeNames.some(
                                        (s) => s.value === item.value
                                    );
                                    return (
                                        <li
                                            key={index}
                                            className={`dd-list-item ${checked ? "dd-list-active" : ""}`}
                                            onClick={() => this.handleSelect(item, !checked)}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={checked}
                                                readOnly
                                            />
                                            &nbsp;&nbsp;{item.label}
                                        </li>
                                    );
                                })
                            )}
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}

export default CrispMerchantTradeNameFilter;
